<template>
  <div
    class="flex flex-col gap-6 w-[650px] p-6 rounded-lg bg-white shadow-default"
  >
    <div class="flex gap-4">
      <div
        class="error flex justify-center items-center flex-shrink-0 w-12 h-12 rounded-sm"
      >
        <ErrorIcon />
      </div>
      <div>
        <h2 class="modal-heading">
          {{ changeCase('delete widget', ElementE.TITLE) }}
        </h2>
        <p class="modal-content mt-1">
          {{ changeCase('are you sure you want to delete', ElementE.SUBTITLE) }} "{{ title }}"?
        </p>
      </div>
    </div>

    <div class="flex gap-4 self-end">
      <button class="btn-secondary is-btn-size-default" @click="$emit('close')">
        {{ changeCase('cancel', ElementE.BUTTON) }}
      </button>
      <button class="btn-primary is-btn-size-default" @click="$emit('delete', widgetId)">
        {{ changeCase('delete', ElementE.BUTTON) }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ErrorIcon from "../icons/ErrorIcon.vue";
import { changeCase } from '../../helpers';
import { ElementE } from '../../enums';

export default defineComponent({
  name: "DeleteWidgetModal",
  components: { ErrorIcon },
  props: {
    title: { type: String, default: "" },
    widgetId: { type: String, default: "" },
  },
  data() {
    return {
      changeCase: changeCase,
      ElementE: ElementE,
    }
  },
});
</script>
